import React from 'react';
import { useTranslation } from 'react-i18next';
import { ListPlus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { DialogFooter } from '@/components/ui/dialog';
import { LoadingButton } from '@/components/common/LoadingButton';

interface ConvertWizardFooterProps {
  activeStep: number;
  isSubmitting: boolean;
  canProceedStep1: boolean;
  canProceedStep2: boolean;
  onClose: () => void;
  onBack: () => void;
  onNext: () => void;
  onSubmit: () => void;
}

const ConvertWizardFooter: React.FC<ConvertWizardFooterProps> = ({
  activeStep,
  isSubmitting,
  canProceedStep1,
  canProceedStep2,
  onClose,
  onBack,
  onNext,
  onSubmit,
}) => {
  const { t } = useTranslation();

  return (
    <DialogFooter className="flex-row items-center justify-between gap-2 px-6 py-4 sm:justify-between sm:space-x-0">
      <Button variant="ghost" onClick={onClose} disabled={isSubmitting}>
        <span className="revy-cjk">{t('common.cancel')}</span>
      </Button>

      <div className="flex items-center gap-2">
        {activeStep > 0 && (
          <Button variant="ghost" onClick={onBack} disabled={isSubmitting}>
            <span className="revy-cjk">{t('drbfm.convert.back')}</span>
          </Button>
        )}
        {activeStep < 2 && (
          <Button
            onClick={onNext}
            disabled={activeStep === 0 ? !canProceedStep1 : !canProceedStep2}
          >
            <span className="revy-cjk">{t('drbfm.convert.next')}</span>
          </Button>
        )}
        {activeStep === 2 && (
          <LoadingButton
            onClick={onSubmit}
            loading={isSubmitting}
            loadingText={t('drbfm.convert.submitting')}
          >
            <ListPlus strokeWidth={1.9} />
            <span className="revy-cjk">{t('drbfm.convert.submit')}</span>
          </LoadingButton>
        )}
      </div>
    </DialogFooter>
  );
};

export default ConvertWizardFooter;
